<hr>
<div class="row">
  <div class="col-4 form-group"><label>{{title}}</label></div>
  <div class="col-4">
    <div *ngFor="let item of value">
      {{item.name}}&nbsp;<a *ngIf="edit" (click)="remove(item)" [routerLink]="[]">X</a>
    </div>

  </div>
  <div class="col-4" *ngIf="edit">
    <div class="row">
      <div class="col-8">
        <div class="form-check">
          <input type="checkbox" [(ngModel)]="isExternal" class="form-check-input">
          <label class="form-check-label">free entry</label>
        </div>
        <div class="form-check" *ngIf="!isExternal">
          <input type="checkbox" [(ngModel)]="onlyCustomer" class="form-check-input" (change)="selectOnlyCustomer(onlyCustomer)">
          <label class="form-check-label">only customer</label>
        </div>
        <div class="form-check" *ngIf="!isExternal">
          <input type="checkbox" [(ngModel)]="onlyNrk" class="form-check-input" (change)="selectOnlyNrk(onlyNrk)">
          <label class="form-check-label">only nrk</label>
        </div>
        <input type="text" *ngIf="isExternal" [(ngModel)]="newParticipantName" class="form-control form-control-sm">
        <ng2-completer *ngIf="!isExternal"
          [(ngModel)]="newParticipantName"
          [datasource]="contactService"
          [minSearchLength]="0"
          (selected)="select($event)"
          inputClass="form-control form-control-sm"
        ></ng2-completer>
      </div>
      <div class="col-4">
        <button class="btn btn-primary btn-sm" (click)="addParticipant()">Insert</button>
      </div>
    </div>


  </div>


</div>
<hr>
